<template>
  <b-form id="teryt-search-form">
    <b-alert variant="danger" :show="terytSearchHasError"
      ><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert
    >
    <!-- <b-form-group label="Kod TERYT" label-for="teryt-code-input">
      <small class="text-danger" v-show="terytSearchErrors.terytCodeIsEmpty"
        >Należy podać kod TERYT.</small
      >
      <b-form-input
        @blur.native="terytCodeChanged"
        id="teryt-code-input"
        v-model="terytCode"
        :class="{
          'is-invalid': terytSearchErrors.terytCodeIsEmpty,
          'form-control': true
        }"
      ></b-form-input>
    </b-form-group> -->
    <b-form-group label="Województwo" label-for="teryt-province-select">
      <small
        class="text-danger"
        v-show="terytSearchErrors.terytProvinceNotSelected"
        >Należy wybrać województwo.</small
      >
      <b-form-select
        :disabled="isParcelNumberIsTerytParcelNumber"
        id="teryt-province-select"
        v-model="selectedProvince"
        @change="provinceChanged"
        :class="{
          'is-invalid': terytSearchErrors.terytProvinceNotSelected,
          'form-control': true
        }"
      >
        <option :value="null" disabled>Wybierz</option>
        <option
          v-for="province in provinces"
          :key="province.id"
          :value="province"
        >
          {{ province.nazwa }}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Powiat" label-for="teryt-district-select">
      <small
        class="text-danger"
        v-show="terytSearchErrors.terytDistrictNotSelected"
        >Należy wybrać powiat.</small
      >
      <b-form-select
        :disabled="isParcelNumberIsTerytParcelNumber"
        id="teryt-district-select"
        v-model="selectedDistrict"
        @change="districtChanged"
        :class="{
          'is-invalid': terytSearchErrors.terytDistrictNotSelected,
          'form-control': true
        }"
      >
        <option :value="null" disabled>Wybierz</option>
        <option
          v-for="district in districts"
          :key="district.id"
          :value="district"
        >
          {{ district.nazwa }}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Gmina" label-for="teryt-commune-select">
      <small
        class="text-danger"
        v-show="terytSearchErrors.terytCommuneNotSelected"
        >Należy wybrać gminę.</small
      >
      <b-form-select
        :disabled="isParcelNumberIsTerytParcelNumber"
        id="teryt-commune-select"
        v-model="selectedCommune"
        @change="communeChanged"
        :class="{
          'is-invalid': terytSearchErrors.terytCommuneNotSelected,
          'form-control': true
        }"
      >
        <option :value="null" disabled>Wybierz</option>
        <option v-for="commune in communes" :key="commune.id" :value="commune">
          {{ commune.nazwa }}
        </option>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Obręb" label-for="teryt-perimeter-select">
      <small
        class="text-danger"
        v-show="
          terytSearchErrors.terytPerimeterNotSelected && !perimeterUnknown
        "
        >Należy wybrać obręb.</small
      >
      <b-form-select
        id="teryt-perimeter-select"
        v-model="selectedPerimeter"
        :disabled="perimeterUnknown || isParcelNumberIsTerytParcelNumber"
        @change="perimeterChanged"
        :class="{
          'is-invalid':
            terytSearchErrors.terytPerimeterNotSelected && !perimeterUnknown,
          'form-control': true
        }"
      >
        <option :value="null" disabled>Wybierz</option>
        <option
          v-for="perimeter in perimeters"
          :key="perimeter.teryt"
          :value="perimeter.teryt"
        >
          {{ perimeter.nazwa }}
        </option>
      </b-form-select>
      <b-form-checkbox
        :disabled="isParcelNumberIsTerytParcelNumber"
        button-variant="light"
        v-model="perimeterUnknown"
        v-show="false"
        >Nie znam obrębu</b-form-checkbox
      >
    </b-form-group>
    <b-form-group
      label="Numer działki lub identyfikator działki"
      label-for="teryt-parcel-number-input"
    >
      <small
        class="text-danger"
        v-show="terytSearchErrors.terytParcelNumberIsEmpty"
        >Należy podać numer działki lub identyfikator działki.</small
      >
      <b-form-input
        id="teryt-parcel-number-input"
        v-model="parcelNumber"
        :class="{
          'is-invalid': terytSearchErrors.terytParcelNumberIsEmpty,
          'form-control': true
        }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Identyfikator działki" label-for="parcel-code-input">
      <b-form-input
        id="parcel-code-input"
        v-model="terytParcelNumber"
        readonly="readonly"
        :class="{ 'form-control': true }"
      ></b-form-input>
    </b-form-group>
    <b-form-group>
      <b-row
        ><b-col
          ><b-btn
            @click="clearTerytForm()"
            variant="secondary"
            class="col-md-12"
            size="sm"
            :disabled="submittingTerytSearch"
          >
            <span>Wyczyść</span>
          </b-btn> </b-col
        ><b-col
          ><b-btn
            @click="submitTerytSearch()"
            variant="primary"
            class="col-md-12"
            size="sm"
            :disabled="submittingTerytSearch"
          >
            <span v-show="!submittingTerytSearch">Szukaj</span>
            <icon
              v-show="submittingTerytSearch"
              name="circle-notch"
              spin
            ></icon> </b-btn></b-col
      ></b-row>
    </b-form-group>
  </b-form>
</template>

<script>
import { SEARCH_TERYTPARCEL_GET } from '../../store/actions.type';
import {
  SEARCH_LOADER_SHOW,
  SEARCH_LOADER_HIDE,
  WINDOW_API_ERROR_SHOW
} from '../../store/mutations.type';
import { Api as SearchApi } from '../../api/api-wyszukiwarka.js';
import { Api as CustomApi } from '../../api/custom-api.js';
export default {
  name: 'TerytSearch',
  data() {
    return {
      terytSearchErrors: {
        terytCodeIsEmpty: false,
        terytProvinceNotSelected: false,
        terytDistrictNotSelected: false,
        terytCommuneNotSelected: false,
        terytPerimeterNotSelected: false,
        terytParcelNumberIsEmpty: false
      },
      terytCode: '',
      provinces: [],
      selectedProvince: null,
      districts: [],
      selectedDistrict: null,
      communes: [],
      selectedCommune: null,
      perimeters: [],
      selectedPerimeter: null,
      perimeterUnknown: false,
      perimeter: '',
      parcelNumber: '',
      submittingTerytSearch: false,
      control: ''
    };
  },
  mounted() {
    this.getTerytSearchData();
  },
  methods: {
    submitTerytSearch() {
      if (this.isValid()) {
        this.$store.dispatch(SEARCH_TERYTPARCEL_GET, {
          terytSearchObject: this.terytParcelNumber,
          parcelNumber: this.parcelNumber
        });
      }
    },
    clearTerytForm() {
      this.clearDataOnTerytChange();

      this.parcelNumber = '';

      this.terytCode = '';
    },
    isValid() {
      if (this.isParcelNumberIsTerytParcelNumber) {
        this.terytSearchErrors.terytProvinceNotSelected = false;
        this.terytSearchErrors.terytDistrictNotSelected = false;
        this.terytSearchErrors.terytCommuneNotSelected = false;
        this.terytSearchErrors.terytPerimeterNotSelected = false;
        this.terytSearchErrors.terytParcelNumberIsEmpty = false;
        return true;
      } else {
        this.terytSearchErrors.terytProvinceNotSelected = !this
          .selectedProvince;
        this.terytSearchErrors.terytDistrictNotSelected = !this
          .selectedDistrict;
        this.terytSearchErrors.terytCommuneNotSelected = !this.selectedCommune;
        this.terytSearchErrors.terytPerimeterNotSelected =
          !this.selectedPerimeter && !this.perimeterUnknown;
        this.terytSearchErrors.terytParcelNumberIsEmpty = !this.parcelNumber;

        if (this.terytSearchHasError) return false;
        return true;
      }
    },
    terytCodeChanged() {
      const regex = /([0-9]{6}[_]{1}[0-9]{1})/g;
      var matches = this.terytCode.length > 0 && regex.test(this.terytCode);

      if (
        this.terytCode.length > 0 &&
        this.terytCode.length <= 8 &&
        (!isNaN(this.terytCode) || matches)
      ) {
        this.clearDataOnTerytChange();
        this.getTerytSearchData(true);
      } else if (this.terytCode === '') {
        this.clearDataOnTerytChange();
      }
    },
    clearDataOnTerytChange() {
      this.selectedProvince = null;
      this.selectedDistrict = null;
      this.selectedCommune = null;
      this.selectedPerimeter = null;
      this.districts = [];
      this.communes = [];
      this.perimeters = [];
      this.perimeter = '';
    },
    async getTerytSearchData(searchPerimeters) {
      this.$store.commit(SEARCH_LOADER_SHOW);
      try {
        if (
          (this.terytCode === '' || this.terytCode.length < 2) &&
          this.selectedProvince == null
        ) {
          await this.searchVivoideship();
        } else if (this.terytCode.length >= 2 && this.terytCode.length < 4) {
          await this.checkProvinces();
          await this.searchCounty();
        } else if (this.terytCode.length >= 4 && this.terytCode.length < 9) {
          await this.checkProvinces();
          await this.checkDistrict();
          await this.checkCommune();
        }

        // jesli nastapila zmiana kodu teryt
        if (
          searchPerimeters &&
          this.selectedDistrict != null &&
          this.selectedCommune != null
        ) {
          await this.getPerimeters();
        }

        this.$store.commit(SEARCH_LOADER_HIDE);
      } catch (e) {
        this.$store.commit(SEARCH_LOADER_HIDE);
        this.$store.commit(WINDOW_API_ERROR_SHOW);
      }
    },
    async checkProvinces() {
      let maxCodeLength = 2;
      if (this.provinces.length == 0) {
        await this.searchVivoideship();
      }
      if (
        this.selectedProvince == null &&
        this.terytCode.length >= maxCodeLength
      ) {
        var code = this.terytCode.substr(0, maxCodeLength);
        this.selectedProvince = this.provinces.find(
          item => item.teryt === code
        );
      }
    },
    async checkDistrict() {
      let maxCodeLength = 4;
      if (this.districts.length == 0) {
        await this.searchCounty();
      }
      if (
        this.selectedDistrict == null &&
        this.terytCode.length >= maxCodeLength
      ) {
        var code = this.terytCode.substr(0, maxCodeLength);
        this.selectedDistrict = this.districts.find(
          item => item.teryt === code
        );
      }
    },
    async checkCommune() {
      let maxCodeLength = 8;
      await this.searchCommune();
      if (
        this.selectedCommune == null &&
        this.terytCode.length >= maxCodeLength
      ) {
        var code = this.terytCode.substr(0, maxCodeLength);
        this.selectedCommune = this.communes.find(item => item.teryt === code);
      }
    },
    getTerytCode(maxCodeLength) {
      return this.terytCode.substr(0, maxCodeLength);
    },
    async searchVivoideship() {
      let api = new CustomApi();
      var response = await api.searchVivoideship({
        id: this.getTerytCode(0)
      });
      var obj = this.splitResponse(response.body);
      this.provinces = obj;
    },
    async searchCounty() {
      let api = new CustomApi();
      var response = await api.searchCounty({
        id: this.getTerytCode(2)
      });
      var obj = this.splitResponse(response.body);
      this.districts = obj;
    },
    async searchCommune() {
      let api = new CustomApi();
      var response = await api.searchCommune({
        id: this.getTerytCode(4)
      });
      var obj = this.splitResponse(response.body);
      this.communes = obj;
    },
    async searchPerimeters() {
      let api = new CustomApi();
      var response = await api.searchRegion({
        id: this.terytCode
      });
      var obj = this.splitResponse(response.body);
      this.perimeters = obj;
    },
    splitResponse(responseText) {
      if (responseText.charAt(0) === '0') {
        responseText = responseText.replace('0\n', '');
        let splited = responseText.split('\n');
        let splitedObj = [];
        splited.forEach(x => {
          x = x.split('|');
          if (x[1] !== undefined) {
            splitedObj.push({
              id: null,
              nazwa: x[0],
              teryt: x[1]
            });
          }
        });
        return splitedObj;
      }
      return [];
    },
    async getPerimeters() {
      this.$store.commit(SEARCH_LOADER_SHOW);
      try {
        await this.searchPerimeters();
        this.$store.commit(SEARCH_LOADER_HIDE);
      } catch (e) {
        this.$store.commit(SEARCH_LOADER_HIDE);
        this.$store.commit(WINDOW_API_ERROR_SHOW);
      }
    },
    provinceChanged(province) {
      if (province != null) {
        this.selectedProvince = province;
        this.terytCode = province.teryt;
        this.selectedDistrict = null;
        this.selectedCommune = null;
        this.selectedPerimeter = null;
        this.perimeters = [];
        this.communes = [];
        this.perimeter = '';
        this.getTerytSearchData();
      }
    },
    districtChanged(district) {
      if (district != null) {
        this.selectedDistrict = district;
        this.terytCode = district.teryt;
        this.selectedCommune = null;
        this.selectedPerimeter = null;
        this.perimeters = [];
        this.perimeter = '';
        this.getTerytSearchData();
      }
    },
    communeChanged(commune) {
      if (commune != null) {
        this.selectedCommune = commune;
        this.terytCode = commune.teryt;
        this.perimeter = '';
        this.selectedPerimeter = null;
        if (this.selectedDistrict != null) {
          this.getPerimeters();
        }
      }
    },
    perimeterChanged(perimeter) {
      if (perimeter != null) {
        this.perimeter = perimeter.substr(this.terytCode.length + 1);
      }
    }
  },
  watch: {
    isParcelNumberIsTerytParcelNumber() {
      if (this.isParcelNumberIsTerytParcelNumber) {
        this.clearDataOnTerytChange();
      }
    }
  },
  computed: {
    terytSearchHasError() {
      return (
        this.terytSearchErrors.terytProvinceNotSelected ||
        this.terytSearchErrors.terytDistrictNotSelected ||
        this.terytSearchErrors.terytCommuneNotSelected ||
        this.terytSearchErrors.terytPerimeterNotSelected ||
        this.terytSearchErrors.terytParcelNumberIsEmpty
      );
    },
    isParcelNumberIsTerytParcelNumber() {
      const regex = /([0-9]{6}[_]{1}[0-9]{1}[.]{1}[0-9]{4}[.]{1}[0-9]+)/g;
      return this.parcelNumber.length > 14 && regex.test(this.parcelNumber);
    },
    terytParcelNumber() {
      var formatedTerytCode = this.selectedPerimeter
        ? this.selectedPerimeter
        : this.terytCode;
      return this.isParcelNumberIsTerytParcelNumber
        ? this.parcelNumber.replace(/\s/g, '') //if ParcelNumberIsTerytParcelNumber then remove spaces
        : formatedTerytCode +
            (this.parcelNumber ? `.${this.parcelNumber}` : '');
    }
  }
};
</script>

<style>
.data-source {
  font-size: 0.75em;
}
</style>
